import { useState } from "react";

// Desktop: the image zooms in under the cursor and follows it; moving away zooms back out.
// Touch screens (no hover): tap the image to zoom in on that spot, tap again to zoom out.
export default function HoverZoom({ src, alt, scale = 2 }) {
  const [active, setActive] = useState(false);
  const [origin, setOrigin] = useState({ x: 50, y: 50 });

  const canHover =
    typeof window !== "undefined" &&
    window.matchMedia?.("(hover: hover) and (pointer: fine)").matches;

  function updateOrigin(e) {
    const rect = e.currentTarget.getBoundingClientRect();
    setOrigin({
      x: ((e.clientX - rect.left) / rect.width) * 100,
      y: ((e.clientY - rect.top) / rect.height) * 100,
    });
  }

  return (
    <div
      className={`hz${active ? " is-zoomed" : ""}`}
      onMouseEnter={() => canHover && setActive(true)}
      onMouseMove={(e) => canHover && updateOrigin(e)}
      onMouseLeave={() => canHover && setActive(false)}
      onClick={(e) => {
        if (canHover) return;
        updateOrigin(e);
        setActive((a) => !a);
      }}
    >
      <img
        src={src}
        alt={alt}
        draggable="false"
        style={{
          transformOrigin: `${origin.x}% ${origin.y}%`,
          transform: active ? `scale(${scale})` : "scale(1)",
        }}
      />
    </div>
  );
}